import { render, staticRenderFns } from "./ModernModal.vue?vue&type=template&id=61cceb55&scoped=true&"
import script from "./ModernModal.vue?vue&type=script&lang=js&"
export * from "./ModernModal.vue?vue&type=script&lang=js&"
import style0 from "./ModernModal.vue?vue&type=style&index=0&id=61cceb55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cceb55",
  null
  
)

export default component.exports